import { userService } from '../../_services';
import router from '../../router/index'
import Userauth from '../../auth/js/index'

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null };

export const authentication = {
    namespaced: true,
    state: initialState,
    getters: {

    },
    actions: {
        login({ dispatch, commit }, { email, password, remember }) {
            commit('loginRequest', { email });
            userService.login(email, password, remember)
                .then(
                    user => {
                        //
                        // const layout = user.layout ? user.layout : ""
                        // const menu = user.menu ? user.menu : ""
                        // console.log(user)
                        // unset
                        // delete user['layout']
                        // delete user['menu']

                        commit('loginSuccess', user);

                        // commit('layout/set', layout, { root: true})
                        
                        // userService.getAll().then( info => {
                            // Userauth.localLogin(user, remember);
                            // setup layout
                            // dispatch('layout/set', "", { root: true})
                        // })
                        // sucess
                        // dispatch('alert/success', "Successfully Logged", { root: true})

                        // set up menu

                        router.push('/');
                    },
                    error => {
                        commit('loginFailure', error);

                        if (error.response.data.includes('not active') || error.response.data.includes('not verified')) {
                            dispatch('alert/warning', error.response.data, { root: true });
                        } else {
                            dispatch('alert/error', error.response.data, { root: true });
                        }

                        return error
                    }
                );
        },
        refresh({ dispatch, commit }, { token, refresh_token }) {
            commit('refreshRequest', { refresh_token });
            userService.refresh(token, refresh_token)
                .then(
                    user => {
                        commit('refreshSuccess', user);
                        // router.push('/');

                        // Userauth.refreshToken()
                    },
                    error => {
                        commit('refreshFailure', error);
                        dispatch('alert/error', error, { root: true });

                        // dispatch a logout
                        dispatch('authentication/logout', {}, { root: true })

                        // router.push('/auth/login');
                    }
                );
        },
        logout({ dispatch, commit }) {
                
            commit('logout');
            userService.logout();
            
            dispatch('alert/clear', {} ,{ root: true });
                
            // Userauth.Logout()

            router.push('/auth/login');
            
        }
    },
    mutations: {
        loginRequest(state, user) {
            state.status = { loggingIn: true };
            state.user = user;
        },
        refreshRequest(state, user) {
            state.status = { refreshingToken: true };
            state.user = user;
        },
        loginSuccess(state, user) {
            state.status = { loggedIn: true };
            state.user = user;
        },
        loginFailure(state) {
            state.status = {};
            state.user = null;
        },
        refreshSuccess(state, user) {
            state.status = { loggedIn: true, refreshedToken: true };
            state.user = user;
        },
        refreshFailure(state) {
            state.status = {};
            state.user = null;
        },
        logout(state) {
            state.status = {};
            state.user = null;
        },
        setToken(state, token) {
            state.token = token
            state.status.loggedIn = true
        }
    }
}